module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQAAAAB/ecQqAAAAAnRSTlMAAHaTzTgAAAAeSURBVHgBY6AW+MBPJGX/gf8Pdoo8gNdM4l1GJQAAivsdxcvmSJAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/exit-full-screen.png
// module id = 1098
// module chunks = 0